
<ng-table-pagination 
  [rows]="rows" 
  [columns]="columns" 
  [totalItems]="totalItems"
  (tableChanged)="getOutstandingTrades($event)">
</ng-table-pagination>